import styled from 'styled-components/macro';
import { DefaultButtonStyled, LabelStyled, SVGIconCustomWrapperStyled, } from '@yme/atoms/button/styled';
import { Link } from '@yme/components/Link';
import { colorBlackTransparent0, colorBlackTransparent200, colorBrandYamahaRed, colorCoreGray600, colorCoreWhite1000, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { ellipsisEndingLine, getTextStyles, transformSrcSetToCss } from '@yme/utils/styles';
export const CardWrapperStyled = styled(FlexWrapper) `
  justify-content: flex-end;

  ${ADAPTIVE.maxWidth.tablet} {
    display: none;
  }
`;
export const CardStyled = styled.section `
  position: relative;
  display: flex;
  flex-direction: column;
  width: 532px;
  height: 299px;
  padding: ${INDENT.sm};
  box-sizing: border-box;

  background-color: ${colorCoreGray600};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  ${({ srcSet, backgroundUrl }) => transformSrcSetToCss(srcSet, backgroundUrl, `linear-gradient(0deg, ${colorBlackTransparent200} 0%, ${colorBlackTransparent0} 57.71%)`)}

  ${ADAPTIVE.minWidth.desktop} {
    width: ${({ isSmall }) => (isSmall ? '282px' : '100%')};
    height: 282px;

    ${({ isSmall }) => isSmall && 'min-width: 282px'};

    ${({ isSmall, isRightToLeft }) => isSmall && `${isRightToLeft ? 'margin-right' : 'margin-left'}: ${INDENT.sm}`};
  }

  ${ADAPTIVE.minWidth.desktopLg} {
    width: ${({ isSmall }) => (isSmall ? '370px' : '660px')};
    height: 371px;
    ${({ isSmall, isRightToLeft }) => isSmall && `${isRightToLeft ? 'margin-right' : 'margin-left'}: ${INDENT.sm}`};
  }
`;
export const CardInnerStyled = styled.div `
  margin-top: auto;
`;
export const LinkStyled = styled(Link) `
  display: inline-block;
  margin-top: ${INDENT.sm};
  text-decoration: none;

  ${DefaultButtonStyled} {
    max-width: 322px;
  }

  ${SVGIconCustomWrapperStyled} {
    max-width: 100%;
  }

  ${LabelStyled} {
    ${ellipsisEndingLine}
  }
`;
export const SaleLabelStyled = styled.span `
  position: absolute;

  top: ${INDENT.sm};
  padding: ${INDENT.xxxxs} ${INDENT.xxs};

  ${({ isRightToLeft }) => (isRightToLeft ? `right: ${INDENT.sm};` : `left: ${INDENT.sm};`)}

  ${getTextStyles('Ubuntu', null, 16, 24)}

  color: ${colorCoreWhite1000};
  border-radius: ${CORNER_RADIUS.xs};
  background-color: ${colorBrandYamahaRed};
`;
